import { FlexBox } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components"
import { LayoutConst, modalControllerSelector } from "core";
import ArrowRight from "shared/assets/24/ArrowRight";
import { BrgButton } from "shared/components/buttons";
import { navbarCreateTooltipProps } from "shared/constants/tooptipStyles";
import ReactTooltip from "react-tooltip";
import { ActiveCompetitionSelector, CompetitionActionPanelActions, ProjectValiditySelector } from "shared/reducers/CompetitionActionPanel";
import { FC, useMemo } from "react";
import BackIcon from "shared/icons/BackIcon";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useProfile } from "@brg/auth";
import useQueryState from "shared/hooks/useQueryState";
import {
    BackButtonWrapper,
    TopBar,
    BottomBar,
    BottomBarContent,
    ProjectName,
    ButtonHolder,
    Button,
    ArrowRightIcon
} from "./styles";



interface PropsT {
    projectTags?: string[];
    onPublish: () => void;
    onPreview?: () => void;
    projecTitle?: string;
    disabled?: boolean;
    errors?: string[];
}

const CompetitionPanel: FC<PropsT> = ({
    projectTags,
    onPublish,
    onPreview,
    projecTitle,
}) => {
    const { t, i18n } = useTranslation();
    const activeCompetition = useSelector(ActiveCompetitionSelector);
    const { projectIsValid, projectErrors } = useSelector(ProjectValiditySelector);
    const modal = useSelector(modalControllerSelector);
    const [{ isPreview }, setQueryParams] = useQueryState();
    const history = useHistory();
    const profile = useProfile();

    const handleClick = () => {
        if (!projectIsValid) {
            return;
        }
        onPublish();
    }

    const onExit = () => {
        if (isPreview) {
            setQueryParams({ isPreview: undefined });
        } else {
            CompetitionActionPanelActions.resetCurrentCompetition();
            history.push(CreateLinkTo.competition(activeCompetition?.competitionId || ''));
        }
    }

    const noRequiredTags = useMemo(() => {
        return !projectTags?.some((tag) => activeCompetition?.requredTagIds?.includes(tag));
    }, [projectTags, activeCompetition?.requredTagIds]);

    const noRequiredTagsError = noRequiredTags ? [t('create.tips.competition_tags')] : [];

    const errorsArray = useMemo(() => {
        return [...projectErrors, ...noRequiredTagsError];
    }, [projectErrors, noRequiredTagsError]);

    const tooltipProps = errorsArray?.length ? {
        'data-tip': errorsArray[0],
        'data-for': 'tooltip-navbar-create'
    } : {};

    const buttonIsDisabled = noRequiredTags || !projectIsValid;

    const backText = useMemo(() => {
        return isPreview ? t('nav.exit_preview') : t('nav.exit_other');
    }, [isPreview, i18n.language]);

    if (!!modal.name || !activeCompetition?.competitionId) {
        return null;
    }

    return (
        <>
            <TopBar>
                <BackButtonWrapper onClick={onExit}>
                    <BackIcon />
                    <span>{backText}</span>
                </BackButtonWrapper>
            </TopBar >
            <BottomBar>
                <BottomBarContent justify="space-between">
                    <ProjectName>
                        {projecTitle || t('project_edit.new_project_title')}
                    </ProjectName>
                    <ButtonHolder>
                        {!!onPreview && (
                            <Button variant='secondary' onClick={onPreview}>
                                {t('nav.preview')}
                            </Button>
                        )}
                        <Button {...tooltipProps} variant='primary' onClick={handleClick} disabled={buttonIsDisabled}>
                            {t('nav.publish')}
                            <ArrowRightIcon />
                        </Button>
                    </ButtonHolder>
                </BottomBarContent>
                <ReactTooltip {...navbarCreateTooltipProps} />
            </BottomBar>
        </>
    )
}

export default CompetitionPanel;import { FlexBox } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components"
import { LayoutConst, modalControllerSelector } from "core";
import ArrowRight from "shared/assets/24/ArrowRight";
import { BrgButton } from "shared/components/buttons";
import { navbarCreateTooltipProps } from "shared/constants/tooptipStyles";
import ReactTooltip from "react-tooltip";
import { ActiveCompetitionSelector, CompetitionActionPanelActions, ProjectValiditySelector } from "shared/reducers/CompetitionActionPanel";
import { FC, useMemo } from "react";
import BackIcon from "shared/icons/BackIcon";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useProfile } from "@brg/auth";
import useQueryState from "shared/hooks/useQueryState";
import {
    BackButtonWrapper,
    TopBar,
    BottomBar,
    BottomBarContent,
    ProjectName,
    ButtonHolder,
    Button,
    ArrowRightIcon
} from "./styles";



interface PropsT {
    projectTags?: string[];
    onPublish: () => void;
    onPreview?: () => void;
    projecTitle?: string;
    disabled?: boolean;
    errors?: string[];
}

const CompetitionPanel: FC<PropsT> = ({
    projectTags,
    onPublish,
    onPreview,
    projecTitle,
}) => {
    const { t, i18n } = useTranslation();
    const activeCompetition = useSelector(ActiveCompetitionSelector);
    const { projectIsValid, projectErrors } = useSelector(ProjectValiditySelector);
    const modal = useSelector(modalControllerSelector);
    const [{ isPreview }, setQueryParams] = useQueryState();
    const history = useHistory();
    const profile = useProfile();

    const handleClick = () => {
        if (!projectIsValid) {
            return;
        }
        onPublish();
    }

    const onExit = () => {
        if (isPreview) {
            setQueryParams({ isPreview: undefined });
        } else {
            CompetitionActionPanelActions.resetCurrentCompetition();
            history.push(CreateLinkTo.competition(activeCompetition?.competitionId || ''));
        }
    }

    const noRequiredTags = useMemo(() => {
        return !projectTags?.some((tag) => activeCompetition?.requredTagIds?.includes(tag));
    }, [projectTags, activeCompetition?.requredTagIds]);

    const noRequiredTagsError = noRequiredTags ? [t('create.tips.competition_tags')] : [];

    const errorsArray = useMemo(() => {
        return [...projectErrors, ...noRequiredTagsError];
    }, [projectErrors, noRequiredTagsError]);

    const tooltipProps = errorsArray?.length ? {
        'data-tip': errorsArray[0],
        'data-for': 'tooltip-navbar-create'
    } : {};

    const buttonIsDisabled = noRequiredTags || !projectIsValid;

    const backText = useMemo(() => {
        return isPreview ? t('nav.exit_preview') : t('nav.exit_other');
    }, [isPreview, i18n.language]);

    if (!!modal.name || !activeCompetition?.competitionId) {
        return null;
    }

    return (
        <>
            <TopBar>
                <BackButtonWrapper onClick={onExit}>
                    <BackIcon />
                    <span>{backText}</span>
                </BackButtonWrapper>
            </TopBar >
            <BottomBar>
                <BottomBarContent justify="space-between">
                    <ProjectName>
                        {projecTitle || t('project_edit.new_project_title')}
                    </ProjectName>
                    <ButtonHolder>
                        {!!onPreview && (
                            <Button variant='secondary' onClick={onPreview}>
                                {t('nav.preview')}
                            </Button>
                        )}
                        <Button {...tooltipProps} variant='primary' onClick={handleClick} disabled={buttonIsDisabled}>
                            {t('nav.publish')}
                            <ArrowRightIcon />
                        </Button>
                    </ButtonHolder>
                </BottomBarContent>
                <ReactTooltip {...navbarCreateTooltipProps} />
            </BottomBar>
        </>
    )
}

export default CompetitionPanel;